import { getUser, setUser } from './base/auth';
import { http } from './base/http';
import type { Creative, CreativeDetails, CreativeListResponse } from './types/creative';
import type { Export } from './types/export';

export const CreativeAPIs = {
    async getCreativeList(query: string): Promise<CreativeListResponse> {
        const endpoint = `/creatives${query}`;
        return await http.get<CreativeListResponse>(endpoint);
    },
    async getCreative(creativeId: number): Promise<CreativeDetails> {
        const endpoint = `/creatives/${creativeId}`;
        return await http.get<CreativeDetails>(endpoint);
    },
    async createCreative(data: {
        name: string;
        template: number;
        template_version: number;
        creative_variants: { variant: number }[];
    }): Promise<Creative> {
        const endpoint = '/creatives';
        return await http.post<Creative>(endpoint, data);
    },
    async updateCreative(creativeId: number, data: Record<string, unknown>): Promise<Creative> {
        const endpoint = `/creatives/${creativeId}`;
        return await http.patch<Creative>(endpoint, data);
    },
    async getExports(creativeId: number): Promise<Export[]> {
        const endpoint = `/creatives/${creativeId}/exports`;
        return await http.get<Export[]>(endpoint);
    },
};
